import { StandardLinkInterface } from 'types/LinkInterface';

const isStandarLinkInterface = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    object: any,
): object is StandardLinkInterface => {
    if (object) {
        return 'url' in object;
    } else {
        return false;
    }
};

export { isStandarLinkInterface };
